<template>
  <button class="icon_btn" :class="disabled ? 'disabled' : ''" :style="btnStyle" @click="$emit('click')"></button>
</template>

<script>

    //按钮大小 26px * 26px
    export default {
        name: "IconBtn",
        props: {
            btnStyle: {
                type: Object,
                required: false
            },
            disabled: {
                required: false
            }
        },
    }
</script>

<style scoped>
  .icon_btn {
    min-width: 26px;
    min-height: 26px;
    border-radius: 4px;
    transition: background-color .1s ease;
    border: 1px solid #d7dae2;
    outline: 0;
    background: white;
    cursor: pointer;
  }

  .icon_btn.disabled {
    cursor: auto;
  }

  .icon_btn.disabled:hover {
    background-color: initial;
  }

  .icon_btn:hover {
    background-color: #CCC;
  }

</style>



// WEBPACK FOOTER //
// src/view/baseComponent/IconBtn.vue